import React from 'react';
import Backdrop from '../../Backdrop/Backdrop';
import Aux from '../../../../containers/hoc/Auxiliary';
import SideDrawerCloseButton from '../../../UI/Buttons/SideDrawerCloseButton/SideDrawerCloseButton';
import backIcon from '../../../../icons/rightFacingBack.svg';

import classes from './TrdHowItWorks.css';

const trdHowItWorks = props => {

    let attachedClasses = [classes.HowItWorks, classes.Close];

    if (props.open) {
        attachedClasses = [classes.HowItWorks, classes.Open];
    }


    return (
        <Aux>
            
            <Backdrop
                show={props.open}
                clicked={props.closed} />

                <div className={attachedClasses.join(' ')}>
                    <div className={classes.SideDrawerCloseButton} >
                        <SideDrawerCloseButton clicked={props.closed} icon={backIcon} />
                    </div>
                    
                    <h3>Here's How It Works:</h3>
                    <hr></hr>
                    <p>1 submission per person (per IP)</p>
                    <p>When this form closes the names submitted will be shuffled in a random manner
                        (This shuffling process will take place a random number of times to really get the list mixed up!)
                    </p>
                    <p>Once the dust settles, The winners will be selected off the top of the list!</p>                
                    <p>Those winners will be sent a PayPal money request which must be paid right away</p>
                    <p>Please feel free to join our email drop list for exclusive email only drops, sneak
                        peeks, product beta testing, and more!
                    </p>
                    <hr></hr>
                    <h1 className={classes.BestWishes}>GoodLuck!</h1>
                    
                </div>
        </Aux>
    )
}

export default trdHowItWorks;


// WEBPACK FOOTER //
// ./src/components/UI/HowItWorks/TrdHowItWorks/TrdHowItWorks.js